export function translateError(err: any) {
	if (err?.message) return err.message
	else return err
}
